/* eslint-disable import/prefer-default-export */
import { useAppSelector } from 'app/hooks'

export const useLiveReportState = () => {
  const liveReportState = useAppSelector(({ liveReport }) => liveReport)
  return liveReportState
}

export const useLiveReportIsValidSession = () => {
  const isValidSession = useAppSelector(({ liveReport }) => liveReport.isValidSession)
  return isValidSession
}

export const useLiveReportUniversalError = () => {
  const error = useAppSelector(({ liveReport }) => liveReport.universalError)
  return error
}

export const useLiveReportCsrfTokenState = () => {
  const csrfTokenState = useAppSelector(({ liveReport }) => liveReport.csrfTokenState)
  return csrfTokenState
}

export const useLiveReportLoginState = () => {
  const login = useAppSelector(({ liveReport }) => liveReport.loginState)
  return login
}

export const useIsProtectedLiveReport = () => {
  const isProtectedReport = useAppSelector(({ liveReport }) => liveReport.isProtectedReport)
  return isProtectedReport
}
